"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactColor = require("react-color");

var _validateColor = _interopRequireDefault(require("validate-color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Picker = {
  block: _reactColor.BlockPicker,
  chrome: _reactColor.ChromePicker,
  compact: _reactColor.CompactPicker,
  github: _reactColor.GithubPicker,
  sketch: _reactColor.SketchPicker,
  swatches: _reactColor.SwatchesPicker,
  twitter: _reactColor.TwitterPicker
};
var DefaultPickerWidth = {
  block: "170px",
  github: "187px",
  sketch: "244px",
  swatches: "322px",
  twitter: "276px"
};
var DefaultPresetColors = {
  block: ["#F44336", "#9C27B0", "#3F51B5", "#2196F3", "#03A9F4", "#00BCD4", "#009688", "#4CAF50", "#8BC34A", "#CDDC39", "#FFEB3B", "#FFC107", "#FF9800", "#9E9E9E", "#607D8B"],
  compact: ["#F44336", "#E91E63", "#9C27B0", "#673AB7", "#3F51B5", "#2196F3", "#03A9F4", "#00BCD4", "#009688", "#4CAF50", "#8BC34A", "#CDDC39", "#FFEB3B", "#FFC107", "#FF9800", "#FF5722", "#795548", "#607D8B", "#bdbdbd", "#9e9e9e", "#757575", "#616161", "#424242", "#000000"],
  github: ["#F44336", "#E91E63", "#9C27B0", "#673AB7", "#3F51B5", "#2196F3", "#03A9F4", "#00BCD4", "#009688", "#4CAF50", "#8BC34A", "#CDDC39", "#FFEB3B", "#FFC107", "#FF9800", "#FF5722", "#795548", "#607d8b", "#455a64", "#9E9E9E", "#616161"],
  sketch: ["#F44336", "#E91E63", "#9C27B0", "#673AB7", "#3F51B5", "#2196F3", "#03A9F4", "#00BCD4", "#009688", "#4CAF50", "#8BC34A", "#CDDC39", "#FFEB3B", "#FFC107", "#FF9800", "#FF5722", "#9e9e9e", "#607d8b"],
  swatches: [["#FF8A80", "#FF5252", "#FF1744", "#D50000"], ["#FF80AB", "#FF4081", "#F50057", "#C51162"], ["#EA80FC", "#E040FB", "#D500F9", "#AA00FF"], ["#B388FF", "#7C4DFF", "#651FFF", "#6200EA"], ["#8C9EFF", "#536DFE", "#3D5AFE", "#304FFE"], ["#80D8FF", "#40C4FF", "#00B0FF", "#0091EA"], ["#84FFFF", "#18FFFF", "#00E5FF", "#00B8D4"], ["#A7FFEB", "#64FFDA", "#1DE9B6", "#00BFA5"], ["#B9F6CA", "#69F0AE", "#00E676", "#00C853"], ["#CCFF90", "#B2FF59", "#76FF03", "#64DD17"], ["#FFFF8D", "#FFFF00", "#FFEA00", "#FFD600"], ["#FFD180", "#FFAB40", "#FF9100", "#FF6D00"]],
  twitter: ["#F44336", "#E91E63", "#9C27B0", "#673AB7", "#3F51B5", "#2196F3", "#03A9F4", "#00BCD4", "#009688", "#4CAF50", "#8BC34A", "#CDDC39", "#FFEB3B", "#FFC107", "#FF9800", "#9E9E9E", "#607D8B"]
};

var ColorControl = /*#__PURE__*/function (_React$Component) {
  _inherits(ColorControl, _React$Component);

  var _super = _createSuper(ColorControl);

  function ColorControl() {
    var _this;

    _classCallCheck(this, ColorControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showColorPicker: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.setState({
        showColorPicker: !_this.state.showColorPicker
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function () {
      _this.props.onChange("");
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        showColorPicker: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (color) {
      var formatedColor = color.rgb.a < 1 ? "rgba(".concat(color.rgb.r, ", ").concat(color.rgb.g, ", ").concat(color.rgb.b, ", ").concat(color.rgb.a, ")") : color.hex;

      _this.props.onChange(formatedColor);
    });

    return _this;
  }

  _createClass(ColorControl, [{
    key: "render",
    value: function render() {
      var allowInput = this.props.field.get("allowInput") || false;
      var DynamicPicker = Picker[this.props.field.get("picker") || "chrome"];
      var presetColors = this.props.field.get("presetColors") ? this.props.field.get("presetColors").toJS() : DefaultPresetColors[this.props.field.get("picker") || ""];
      var pickerWidth = this.props.field.get("pickerWidth") ? this.props.field.get("pickerWidth") : DefaultPickerWidth[this.props.field.get("picker") || ""];
      var _this$props = this.props,
          forID = _this$props.forID,
          value = _this$props.value,
          _onChange = _this$props.onChange,
          classNameWrapper = _this$props.classNameWrapper,
          setActiveStyle = _this$props.setActiveStyle,
          setInactiveStyle = _this$props.setInactiveStyle;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " ", !allowInput && value ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: "relative",
          width: "100%"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        // clear button, not displayed if allowInput: true
        style: {
          position: "absolute",
          right: "6px",
          zIndex: "1000",
          padding: "8px",
          marginTop: "11px"
        },
        onClick: this.handleClear
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        height: "20",
        width: "20",
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "rgb(122, 130, 145)",
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
      })))) : null, /*#__PURE__*/_react["default"].createElement("div", {
        // color swatch background with checkerboard to display behind transparent colors
        style: {
          position: "absolute",
          zIndex: "1",
          background: 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMUlEQVQ4T2NkYGAQYcAP3uCTZhw1gGGYhAGBZIA/nYDCgBDAm9BGDWAAJyRCgLaBCAAgXwixzAS0pgAAAABJRU5ErkJggg==")',
          height: "38px",
          width: "48px",
          marginTop: "10px",
          marginLeft: "10px",
          borderRadius: "5px"
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        // color swatch
        style: {
          position: "absolute",
          zIndex: "2",
          background: (0, _validateColor["default"])(this.props.value) ? this.props.value : "#fff",
          cursor: "pointer",
          height: "38px",
          width: "48px",
          marginTop: "10px",
          marginLeft: "10px",
          borderRadius: "5px",
          border: "2px solid rgb(223, 223, 227)",
          textAlign: "center",
          fontSize: "27px",
          lineHeight: "1",
          paddingTop: "4px",
          userSelect: "none",
          color: (0, _validateColor["default"])(this.props.value) ? "rgba(255, 255, 255, 0)" : "rgb(223, 223, 227)"
        },
        onClick: this.handleClick
      }, "?"), this.state.showColorPicker ? /*#__PURE__*/_react["default"].createElement("div", {
        // color picker container
        style: {
          position: "absolute",
          zIndex: "1000",
          marginTop: "48px",
          marginLeft: "12px"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        // fullscreen div to close color picker when clicking outside of picker
        style: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px"
        },
        onClick: this.handleClose
      }), /*#__PURE__*/_react["default"].createElement(DynamicPicker, {
        color: value || "",
        onChange: this.handleChange,
        triangle: "hide",
        width: pickerWidth,
        height: this.props.field.get("pickerHeight") || "242px",
        colors: presetColors,
        presetColors: presetColors,
        disableAlpha: !this.props.field.get("enableAlpha") || false
      })) : null, /*#__PURE__*/_react["default"].createElement("input", {
        // text input with padding left for the color swatch
        type: "text",
        id: forID,
        className: classNameWrapper,
        value: value || "",
        onChange: function onChange(e) {
          return _onChange(e.target.value);
        },
        onFocus: setActiveStyle,
        onBlur: setInactiveStyle,
        style: {
          paddingLeft: "75px",
          paddingRight: "70px",
          color: !allowInput && "#bbb"
        } // make readonly and open color picker on click if set to allowInput: false
        ,
        onClick: !allowInput && this.handleClick,
        readOnly: !allowInput
      }));
    }
  }]);

  return ColorControl;
}(_react["default"].Component);

exports["default"] = ColorControl;

_defineProperty(ColorControl, "propTypes", {
  onChange: _propTypes["default"].func.isRequired,
  forID: _propTypes["default"].string,
  value: _propTypes["default"].node,
  classNameWrapper: _propTypes["default"].string.isRequired,
  setActiveStyle: _propTypes["default"].func.isRequired,
  setInactiveStyle: _propTypes["default"].func.isRequired
});

_defineProperty(ColorControl, "defaultProps", {
  value: ""
});
//# sourceMappingURL=ColorControl.js.map